import mitt from "mitt";
import type { Emitter } from 'mitt'

// allow any event and gradually add typification
export type EventMap = Emitter<Record<string, any>>

export const emitter = mitt();
export default emitter;